export default __webpack_public_path__ + "static/media/map.15c60c71.svg";